import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M16.898 10.103a.563.563 0 0 1 0 .795l-3 3a.563.563 0 0 1-.796 0L10.5 11.296l-2.603 2.602a.562.562 0 0 1-.795-.795l3-3a.563.563 0 0 1 .796 0l2.602 2.601 2.602-2.601a.563.563 0 0 1 .796 0ZM21.563 12a9.563 9.563 0 0 1-14.128 8.405l-3.269 1.09a1.313 1.313 0 0 1-1.66-1.661l1.09-3.27A9.563 9.563 0 1 1 21.561 12Zm-1.125 0a8.438 8.438 0 1 0-15.743 4.225.562.562 0 0 1 .047.46l-1.168 3.504a.188.188 0 0 0 .237.238l3.502-1.169a.571.571 0 0 1 .46.047A8.436 8.436 0 0 0 20.437 12Z",
  fill: "#000"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }